import { render, staticRenderFns } from "./PolTypeHelpList.vue?vue&type=template&id=523fd8c9&"
import script from "./PolTypeHelpList.vue?vue&type=script&lang=js&"
export * from "./PolTypeHelpList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports